module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-user"
  }, [_c('h3', [_vm._v(_vm._s(_vm.editing ? '编辑' : '创建') + "用户")]), _c('el-form', {
    ref: "form",
    staticClass: "ui form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('div', {
    staticClass: "two fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    class: {
      error: _vm.form_errors.username
    },
    attrs: {
      "prop": "username"
    }
  }, [_c('label', [_vm._v("用户名")]), _c('el-input', {
    attrs: {
      "placeholder": "用户名",
      "disabled": _vm.editing
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    class: {
      error: _vm.form_errors.display
    },
    attrs: {
      "prop": "display"
    }
  }, [_c('label', [_vm._v("显示名")]), _c('el-input', {
    attrs: {
      "placeholder": "显示名"
    },
    model: {
      value: (_vm.form.display),
      callback: function($$v) {
        _vm.$set(_vm.form, "display", $$v)
      },
      expression: "form.display"
    }
  })], 1)], 1), _c('div', {
    staticClass: "two fields"
  }, [_c('el-form-item', {
    staticClass: "ui field",
    class: {
      error: _vm.form_errors.password
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.editing ? '新' : '') + "密码")]), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    class: {
      error: _vm.form_errors.password_repeat
    },
    attrs: {
      "prop": "password_repeat"
    }
  }, [_c('label', [_vm._v("重复密码")]), _c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password_repeat),
      callback: function($$v) {
        _vm.password_repeat = $$v
      },
      expression: "password_repeat"
    }
  })], 1)], 1), _c('div', {
    staticClass: "ui field",
    class: {
      error: _vm.form_errors.roles
    }
  }, [_c('label', [_vm._v("角色")]), _c('el-select', {
    attrs: {
      "multiple": "multiple",
      "placeholder": "选择角色"
    },
    model: {
      value: (_vm.form.roles),
      callback: function($$v) {
        _vm.$set(_vm.form, "roles", $$v)
      },
      expression: "form.roles"
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('el-option', {
      key: role._id,
      attrs: {
        "label": role.name,
        "value": role._id
      }
    })
  }))], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "启用"
    },
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  })], 1), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.editing ? '保存' : '创建'))]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2488d670","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormUser.vue
// module id = 416
// module chunks = 0